import * as CustomSectionService from '../../../../services/customSection.service';
import CustomSectionsType from './CustomSections.type';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as SystemMasterServices from '../../../../services/SystemMaster.services';
import * as BomTypeService from '../../../../services/bom-type.services';

const criticalPath = 'critical-path';

export const fetchCustomSectionList = () => async (dispatch) => {
  try {
    const res = await CustomSectionService.fetchCustomSectionListService({
      type: criticalPath,
    });
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_CUSTOM_SECTION_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addSectionTemplateAction = (data) => async (dispatch) => {
  try {
    const res = await CustomSectionService.addSectionTemplateActionService(
      {
        type: criticalPath,
      },
      data,
    );
    if (res.code === 200) {
      dispatch(fetchCustomSectionList());
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteSection = (id, sectionName) => async (dispatch) => {
  try {
    const res = await CustomSectionService.deleteSectionService(
      {
        sectionType: criticalPath,
        sectionName,
      },
      id,
    );
    if (res.code === 200) {
      dispatch(fetchCustomSectionList());
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCustomColumnList = (sectionId) => async (dispatch) => {
  try {
    const res = await CustomSectionService.fetchCustomColumnListService(sectionId);
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_CUSTOM_SECTION_COLUMNS_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveColumnChanges = (data, columns, t) => async (dispatch) => {
  try {
    const res = await CustomSectionService.saveColumnChangesService(data, columns);
    if (res.code === 200) {
      dispatch(fetchCustomColumnList(data?.sectionId));
      toasterMsg(t(res?.message), 'success');
      return true;
    }
    if (res.code === 500) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteSectionColumn = (id, sectionId, t) => async (dispatch) => {
  try {
    const res = await CustomSectionService.deleteSectionColumnService(
      {
        sectionType: criticalPath,
      },
      id,
      sectionId,
    );
    if (res.code === 200) {
      dispatch(fetchCustomColumnList(sectionId));
    } else {
      toasterMsg(t(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addColumnInSection = (data, sectionId) => async (dispatch) => {
  try {
    const res = await CustomSectionService.addColumnInSectionService(data, sectionId);
    if (res.code === 200) {
      dispatch(fetchCustomColumnList(sectionId));
      toasterMsg('Column added successfullly', 'success');
    }
    if (res?.code === 500) {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setEditData = (data) => async (dispatch) => {
  try {
    await dispatch({
      type: CustomSectionsType.SET_EDIT_COLUMN_DATA,
      payload: data,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return true;
  }
};

export const updateColumnInSection = (data, sectionId, columnId, transactionMsg) => async (dispatch) => {
  try {
    const res = await CustomSectionService.updateColumnInSectionService(data, sectionId, columnId);
    if (res.code === 200) {
      dispatch(fetchCustomColumnList(sectionId));
      toasterMsg(transactionMsg('RANGE_PLANS.CUSTOM_SECTION.INDEX.COLUMN_UPDATED_SUCCESSFULY'), 'success');
    }
    if (res.code === 500) {
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return true;
  }
};

export const getAllCustomAttributes = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllCustomAttribute();
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_CUSTOM_SECTION_DYNAMIC_COLUMNS,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getAllMeasurment = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllMeasurement();
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_ALL_MEASUREMENT_DYNAMIC_COLUMNS,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSampleTrackingDates = () => async (dispatch) => {
  try {
    const res = await SystemMasterServices.getAllSampleTracking();
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_ALL_CUSTOM_SAMPLES_TRACKING,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllSections = () => async (dispatch) => {
  try {
    const res = await CustomSectionService.fetchAllSectionsService();
    if (res.code === 200) {
      await dispatch({
        type: CustomSectionsType.SET_SECTIONS_WITH_COLUMNS,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmount = () => async (dispatch) => {
  try {
    await dispatch({
      type: CustomSectionsType.UNMOUNT_CUSTOM_MODAL,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return true;
  }
};

export const updateSequenceForCustomSection = (params, data) => async () => {
  try {
    await CustomSectionService.updateSequenceForCustomSectionService(params, data); // API
  } catch (error) {
    toasterMsg(error.message, 'danger');
  }
};

// bom type group action start
export const fetchCustomSectionBomTypeAction = (params) => async (dispatch) => {
  try {
    const res = await BomTypeService.fetchBomType(params);
    if (res?.code === 200) {
      await dispatch({
        type: CustomSectionsType.CUSTOM_SECTION_BOM_ALL_TYPES,
        payload: res?.data || [],
      });
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setDefaultSectionAction = (id) => async () => {
  try {
    const res = await CustomSectionService.setDefaultSectionService(id);
    if (res?.code === 200) {
      toasterMsg('Set Default Successfully', 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearSectionList = () => async (dispatch) => {
  try {
    await dispatch({
      type: CustomSectionsType.SET_SECTIONS_WITH_COLUMNS,
      payload: [],
    });
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
